module.exports = __webpack_public_path__ + "img/symbol_6.2e8f48fd.png";